'use client';

interface UserEditModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: { name: string; timezone: string }) => void;
  currentName: string;
  currentTimezone?: string;
  userId: number;
}

export default function UserEditModal({ 
  isOpen,
  onClose,
  onSave,
  currentName,
  currentTimezone = 'UTC+3',
  userId
}: UserEditModalProps) {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const newName = formData.get('name') as string;
    const newTimezone = formData.get('timezone') as string;
    
    if (newName && newName.trim() !== '' && (newName.trim() !== currentName || newTimezone !== currentTimezone)) {
      onSave({
        name: newName.trim(),
        timezone: newTimezone
      });
    }
  };

  if (!isOpen) return null;

  console.log('UserEditModal currentTimezone:', currentTimezone); // ← добавить перед return

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <h3 className="text-lg font-semibold mb-4">Edit Profile</h3>
        
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Current name: <span className="font-semibold">{currentName}</span>
            </label>
            <input
              type="text"
              name="name"
              defaultValue={currentName}
              className="w-full px-3 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-300 bg-white text-gray-900"
              placeholder="Enter your name"
              required
            />
          </div>

          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Timezone
            </label>
            <select
              name="timezone"
              defaultValue={currentTimezone}
              className="w-full px-3 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-300 bg-white text-gray-900 appearance-none cursor-pointer"
            >
              <option value="UTC-8">UTC-8 Vancouver</option>
              <option value="UTC-6">UTC-6 Chicago</option>
              <option value="UTC-4">UTC-4 Toronto</option>
              <option value="UTC+0">UTC+0 London</option>
              {/* <option value="UTC+1">UTC+1 (Berlin, Paris)</option> */}
              {/* <option value="UTC+2">UTC+2 (Athens, Helsinki)</option> */}
              <option value="UTC+3">UTC+3 Moscow</option>
              <option value="UTC+4">UTC+4 Baku</option>
              <option value="UTC+5">UTC+5 Tashkent</option>
              <option value="UTC+6">UTC+6 Dhaka</option>
              <option value="UTC+7">UTC+7 Bangkok</option>
              <option value="UTC+8">UTC+8 Manila</option>
              <option value="UTC+9">UTC+9 Tokyo</option>
              {/* <option value="UTC+10">UTC+10 (Sydney, Melbourne)</option> */}
              {/* <option value="UTC-5">UTC-5 (New York, Toronto)</option> */}
              {/* <option value="UTC-6">UTC-6 (Chicago, Mexico City)</option> */}
              {/* <option value="UTC-7">UTC-7 (Denver, Phoenix)</option> */}
            </select>
          </div>
          
          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-1 text-gray-600 hover:text-gray-800 font-medium"
            >
              Close
            </button>
            <button
              type="submit"
              className="px-4 py-1 bg-blue-500 text-white rounded-md hover:bg-blue-600 font-medium"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
